import Sidemenu from '../components/base/sidemenu';
import AdminManagementRedesign from '../components/admin/AdminManagementRedesign';

export default function AdminPage() {
  return (
    <div className="flex admin-management-layout">
      <Sidemenu />

      <main className="admin-management-content">
        <AdminManagementRedesign />
      </main>
    </div>
  );
}
